/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsPendingTransaction
 */
export interface ControlcenterMelcoModelsPendingTransaction {
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsPendingTransaction
     */
    subscription_start_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPendingTransaction
     */
    old_license_count?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsPendingTransaction
     */
    new_license_count?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPendingTransaction
     */
    old_sub_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsPendingTransaction
     */
    new_sub_type?: string | null;
}

export function ControlcenterMelcoModelsPendingTransactionFromJSON(json: any): ControlcenterMelcoModelsPendingTransaction {
    return ControlcenterMelcoModelsPendingTransactionFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsPendingTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsPendingTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subscription_start_date': !exists(json, 'subscription_start_date') ? undefined : (new Date(json['subscription_start_date'])),
        'old_license_count': !exists(json, 'old_license_count') ? undefined : json['old_license_count'],
        'new_license_count': !exists(json, 'new_license_count') ? undefined : json['new_license_count'],
        'old_sub_type': !exists(json, 'old_sub_type') ? undefined : json['old_sub_type'],
        'new_sub_type': !exists(json, 'new_sub_type') ? undefined : json['new_sub_type'],
    };
}

export function ControlcenterMelcoModelsPendingTransactionToJSON(value?: ControlcenterMelcoModelsPendingTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subscription_start_date': value.subscription_start_date === undefined ? undefined : (value.subscription_start_date.toISOString()),
        'old_license_count': value.old_license_count,
        'new_license_count': value.new_license_count,
        'old_sub_type': value.old_sub_type,
        'new_sub_type': value.new_sub_type,
    };
}


